// AUTO-GENERATED — clay vite bootstrap (do not edit)
// This file is the ESM entry point injected into view-mode pages via
// <script type="module">. It runs the global initializers synchronously,
// then scans the DOM and dynamically imports only the component modules
// present on the current page — keeping initial parse cost low.

window.modules = window.modules || {};

import './_env-init.js';

import './_globals-init.js';


const _clayClientModules = {
  "components/ab-test/client.js": () => import("../components/ab-test/client.js"),
  "components/accordion/client.js": () => import("../components/accordion/client.js"),
  "components/account-2/client.js": () => import("../components/account-2/client.js"),
  "components/ad-recirc/client.js": () => import("../components/ad-recirc/client.js"),
  "components/ad-repeat/client.js": () => import("../components/ad-repeat/client.js"),
  "components/ad-takeover-guinness/client.js": () => import("../components/ad-takeover-guinness/client.js"),
  "components/ad-takeover-homepage/client.js": () => import("../components/ad-takeover-homepage/client.js"),
  "components/ad/client.js": () => import("../components/ad/client.js"),
  "components/affiliate-links/client.js": () => import("../components/affiliate-links/client.js"),
  "components/agree-disagree-quiz/client.js": () => import("../components/agree-disagree-quiz/client.js"),
  "components/ai-search/client.js": () => import("../components/ai-search/client.js"),
  "components/annotations/client.js": () => import("../components/annotations/client.js"),
  "components/apple-podcast/client.js": () => import("../components/apple-podcast/client.js"),
  "components/article-nav/client.js": () => import("../components/article-nav/client.js"),
  "components/article-recirc/client.js": () => import("../components/article-recirc/client.js"),
  "components/article-toc/client.js": () => import("../components/article-toc/client.js"),
  "components/article/client.js": () => import("../components/article/client.js"),
  "components/audio-embed/client.js": () => import("../components/audio-embed/client.js"),
  "components/auth-modal/client.js": () => import("../components/auth-modal/client.js"),
  "components/author/client.js": () => import("../components/author/client.js"),
  "components/baby-growl/client.js": () => import("../components/baby-growl/client.js"),
  "components/banner-callout/client.js": () => import("../components/banner-callout/client.js"),
  "components/bar-line-chart/client.js": () => import("../components/bar-line-chart/client.js"),
  "components/browse-issues/client.js": () => import("../components/browse-issues/client.js"),
  "components/browsi/client.js": () => import("../components/browsi/client.js"),
  "components/categories-header/client.js": () => import("../components/categories-header/client.js"),
  "components/categories-sub-navigation/client.js": () => import("../components/categories-sub-navigation/client.js"),
  "components/ceros-article/client.js": () => import("../components/ceros-article/client.js"),
  "components/choreographer/client.js": () => import("../components/choreographer/client.js"),
  "components/clay-facebook-post/client.js": () => import("../components/clay-facebook-post/client.js"),
  "components/clay-pinterest/client.js": () => import("../components/clay-pinterest/client.js"),
  "components/clay-share/client.js": () => import("../components/clay-share/client.js"),
  "components/clay-subheader/client.js": () => import("../components/clay-subheader/client.js"),
  "components/clay-tiktok/client.js": () => import("../components/clay-tiktok/client.js"),
  "components/cliff-takeover/client.js": () => import("../components/cliff-takeover/client.js"),
  "components/collection-articles-lede/client.js": () => import("../components/collection-articles-lede/client.js"),
  "components/collection-articles/client.js": () => import("../components/collection-articles/client.js"),
  "components/collection-excerpt/client.js": () => import("../components/collection-excerpt/client.js"),
  "components/collection-package/client.js": () => import("../components/collection-package/client.js"),
  "components/collection-silo/client.js": () => import("../components/collection-silo/client.js"),
  "components/collection-videos/client.js": () => import("../components/collection-videos/client.js"),
  "components/column-container/client.js": () => import("../components/column-container/client.js"),
  "components/column-subscribe/client.js": () => import("../components/column-subscribe/client.js"),
  "components/comment-embed/client.js": () => import("../components/comment-embed/client.js"),
  "components/comments-link/client.js": () => import("../components/comments-link/client.js"),
  "components/complex-dropdown/client.js": () => import("../components/complex-dropdown/client.js"),
  "components/concert-ads/client.js": () => import("../components/concert-ads/client.js"),
  "components/contact-form/client.js": () => import("../components/contact-form/client.js"),
  "components/content-cliff/client.js": () => import("../components/content-cliff/client.js"),
  "components/content-feed-article/client.js": () => import("../components/content-feed-article/client.js"),
  "components/content-reveal/client.js": () => import("../components/content-reveal/client.js"),
  "components/context-card-container/client.js": () => import("../components/context-card-container/client.js"),
  "components/coral-talk/client.js": () => import("../components/coral-talk/client.js"),
  "components/coverlines/client.js": () => import("../components/coverlines/client.js"),
  "components/crossword-puzzle/client.js": () => import("../components/crossword-puzzle/client.js"),
  "components/curated-feed/client.js": () => import("../components/curated-feed/client.js"),
  "components/customer-alert-banner/client.js": () => import("../components/customer-alert-banner/client.js"),
  "components/cut-header/client.js": () => import("../components/cut-header/client.js"),
  "components/cut-newsletter-sign-up/client.js": () => import("../components/cut-newsletter-sign-up/client.js"),
  "components/cut-section-feed/client.js": () => import("../components/cut-section-feed/client.js"),
  "components/di-header/client.js": () => import("../components/di-header/client.js"),
  "components/dual-scroll/client.js": () => import("../components/dual-scroll/client.js"),
  "components/editors-picks/client.js": () => import("../components/editors-picks/client.js"),
  "components/episode-recap/client.js": () => import("../components/episode-recap/client.js"),
  "components/fashion-shows-bar/client.js": () => import("../components/fashion-shows-bar/client.js"),
  "components/feed-video-module/client.js": () => import("../components/feed-video-module/client.js"),
  "components/fill-in-the-blank-quiz/client.js": () => import("../components/fill-in-the-blank-quiz/client.js"),
  "components/flip-card-shoppable/client.js": () => import("../components/flip-card-shoppable/client.js"),
  "components/flip-cards-card/client.js": () => import("../components/flip-cards-card/client.js"),
  "components/flip-cards/client.js": () => import("../components/flip-cards/client.js"),
  "components/follow/client.js": () => import("../components/follow/client.js"),
  "components/full-bleed-container/client.js": () => import("../components/full-bleed-container/client.js"),
  "components/gift-game/client.js": () => import("../components/gift-game/client.js"),
  "components/gift-scout-promo/client.js": () => import("../components/gift-scout-promo/client.js"),
  "components/giphy/client.js": () => import("../components/giphy/client.js"),
  "components/global-footer/client.js": () => import("../components/global-footer/client.js"),
  "components/global-nav/client.js": () => import("../components/global-nav/client.js"),
  "components/governors-scrollviz-2018/client.js": () => import("../components/governors-scrollviz-2018/client.js"),
  "components/governors-table-2018/client.js": () => import("../components/governors-table-2018/client.js"),
  "components/growl/client.js": () => import("../components/growl/client.js"),
  "components/gtm/client.js": () => import("../components/gtm/client.js"),
  "components/head-gtm/client.js": () => import("../components/head-gtm/client.js"),
  "components/header-min/client.js": () => import("../components/header-min/client.js"),
  "components/header-navigation/client.js": () => import("../components/header-navigation/client.js"),
  "components/health-warning/client.js": () => import("../components/health-warning/client.js"),
  "components/homepage-article-bar/client.js": () => import("../components/homepage-article-bar/client.js"),
  "components/homepage-article-promo/client.js": () => import("../components/homepage-article-promo/client.js"),
  "components/house-scrollviz-2018/client.js": () => import("../components/house-scrollviz-2018/client.js"),
  "components/house-table-2018/client.js": () => import("../components/house-table-2018/client.js"),
  "components/html-video/client.js": () => import("../components/html-video/client.js"),
  "components/image-collection/client.js": () => import("../components/image-collection/client.js"),
  "components/image-gallery-image/client.js": () => import("../components/image-gallery-image/client.js"),
  "components/image-gallery/client.js": () => import("../components/image-gallery/client.js"),
  "components/image-grid-image/client.js": () => import("../components/image-grid-image/client.js"),
  "components/image-hotspot/client.js": () => import("../components/image-hotspot/client.js"),
  "components/image-layout/client.js": () => import("../components/image-layout/client.js"),
  "components/image-reveal/client.js": () => import("../components/image-reveal/client.js"),
  "components/image-scroll/client.js": () => import("../components/image-scroll/client.js"),
  "components/image-sequence/client.js": () => import("../components/image-sequence/client.js"),
  "components/image-slide/client.js": () => import("../components/image-slide/client.js"),
  "components/image/client.js": () => import("../components/image/client.js"),
  "components/in-article-image-slideshow/client.js": () => import("../components/in-article-image-slideshow/client.js"),
  "components/infographic-olympic-medals/client.js": () => import("../components/infographic-olympic-medals/client.js"),
  "components/interactive-abortion-map/client.js": () => import("../components/interactive-abortion-map/client.js"),
  "components/interactive-awkward-quiz/client.js": () => import("../components/interactive-awkward-quiz/client.js"),
  "components/interactive-boredom-quiz/client.js": () => import("../components/interactive-boredom-quiz/client.js"),
  "components/interactive-color-blind/client.js": () => import("../components/interactive-color-blind/client.js"),
  "components/interactive-disconnected-youth/client.js": () => import("../components/interactive-disconnected-youth/client.js"),
  "components/interactive-education/client.js": () => import("../components/interactive-education/client.js"),
  "components/interactive-firearm-homicide/client.js": () => import("../components/interactive-firearm-homicide/client.js"),
  "components/interactive-freud-quiz/client.js": () => import("../components/interactive-freud-quiz/client.js"),
  "components/interactive-homelessness/client.js": () => import("../components/interactive-homelessness/client.js"),
  "components/interactive-income-inequality/client.js": () => import("../components/interactive-income-inequality/client.js"),
  "components/interactive-life-expectancy/client.js": () => import("../components/interactive-life-expectancy/client.js"),
  "components/interactive-personality-quiz/client.js": () => import("../components/interactive-personality-quiz/client.js"),
  "components/interactive-revenge/client.js": () => import("../components/interactive-revenge/client.js"),
  "components/interactive-super-recognizer/client.js": () => import("../components/interactive-super-recognizer/client.js"),
  "components/interactive-tiles/client.js": () => import("../components/interactive-tiles/client.js"),
  "components/international-banner-callout/client.js": () => import("../components/international-banner-callout/client.js"),
  "components/item-dropdown/client.js": () => import("../components/item-dropdown/client.js"),
  "components/latest-feed/client.js": () => import("../components/latest-feed/client.js"),
  "components/latest-news/client.js": () => import("../components/latest-news/client.js"),
  "components/leaderboard/client.js": () => import("../components/leaderboard/client.js"),
  "components/lede-gallery/client.js": () => import("../components/lede-gallery/client.js"),
  "components/lede-video/client.js": () => import("../components/lede-video/client.js"),
  "components/leftovers-nav/client.js": () => import("../components/leftovers-nav/client.js"),
  "components/listicle-nav-hundred-jokes/client.js": () => import("../components/listicle-nav-hundred-jokes/client.js"),
  "components/listing-nav/client.js": () => import("../components/listing-nav/client.js"),
  "components/listings-search-controller/client.js": () => import("../components/listings-search-controller/client.js"),
  "components/listings-search-filters/client.js": () => import("../components/listings-search-filters/client.js"),
  "components/listings-search-results/client.js": () => import("../components/listings-search-results/client.js"),
  "components/liveblog-update/client.js": () => import("../components/liveblog-update/client.js"),
  "components/love-map/client.js": () => import("../components/love-map/client.js"),
  "components/magazine-issue-tout/client.js": () => import("../components/magazine-issue-tout/client.js"),
  "components/manual-article/client.js": () => import("../components/manual-article/client.js"),
  "components/marketing/client.js": () => import("../components/marketing/client.js"),
  "components/mixpanel/client.js": () => import("../components/mixpanel/client.js"),
  "components/most-popular/client.js": () => import("../components/most-popular/client.js"),
  "components/multiple-choice-quiz/client.js": () => import("../components/multiple-choice-quiz/client.js"),
  "components/nav-dropdown-button/client.js": () => import("../components/nav-dropdown-button/client.js"),
  "components/nav-search-button/client.js": () => import("../components/nav-search-button/client.js"),
  "components/newsfeed/client.js": () => import("../components/newsfeed/client.js"),
  "components/newsletter-flex-text/client.js": () => import("../components/newsletter-flex-text/client.js"),
  "components/newsletter-sign-up-button/client.js": () => import("../components/newsletter-sign-up-button/client.js"),
  "components/newsletter-sign-up-promo/client.js": () => import("../components/newsletter-sign-up-promo/client.js"),
  "components/newsletter-sign-up/client.js": () => import("../components/newsletter-sign-up/client.js"),
  "components/newsletter-slideout/client.js": () => import("../components/newsletter-slideout/client.js"),
  "components/newsletter-speed-bump/client.js": () => import("../components/newsletter-speed-bump/client.js"),
  "components/newsletters-container/client.js": () => import("../components/newsletters-container/client.js"),
  "components/nymag-header/client.js": () => import("../components/nymag-header/client.js"),
  "components/nymag-latest-feed/client.js": () => import("../components/nymag-latest-feed/client.js"),
  "components/obama-item/client.js": () => import("../components/obama-item/client.js"),
  "components/obama-nav/client.js": () => import("../components/obama-nav/client.js"),
  "components/omniture/client.js": () => import("../components/omniture/client.js"),
  "components/package-navigation/client.js": () => import("../components/package-navigation/client.js"),
  "components/package-table-of-contents/client.js": () => import("../components/package-table-of-contents/client.js"),
  "components/paginated-feed/client.js": () => import("../components/paginated-feed/client.js"),
  "components/peek-and-persist/client.js": () => import("../components/peek-and-persist/client.js"),
  "components/perks/client.js": () => import("../components/perks/client.js"),
  "components/podcast-subscribe/client.js": () => import("../components/podcast-subscribe/client.js"),
  "components/privacy-request-form/client.js": () => import("../components/privacy-request-form/client.js"),
  "components/product-generator/client.js": () => import("../components/product-generator/client.js"),
  "components/product-grid-item/client.js": () => import("../components/product-grid-item/client.js"),
  "components/product-image-hotspot/client.js": () => import("../components/product-image-hotspot/client.js"),
  "components/product-list/client.js": () => import("../components/product-list/client.js"),
  "components/product-sale-alert-promotion/client.js": () => import("../components/product-sale-alert-promotion/client.js"),
  "components/product/client.js": () => import("../components/product/client.js"),
  "components/products-package/client.js": () => import("../components/products-package/client.js"),
  "components/profitwell-inject/client.js": () => import("../components/profitwell-inject/client.js"),
  "components/progress-bar/client.js": () => import("../components/progress-bar/client.js"),
  "components/promotional-spot/client.js": () => import("../components/promotional-spot/client.js"),
  "components/quiz-personality/client.js": () => import("../components/quiz-personality/client.js"),
  "components/quote-generator/client.js": () => import("../components/quote-generator/client.js"),
  "components/read-more/client.js": () => import("../components/read-more/client.js"),
  "components/redirect/client.js": () => import("../components/redirect/client.js"),
  "components/refresher-course/client.js": () => import("../components/refresher-course/client.js"),
  "components/registration-wall/client.js": () => import("../components/registration-wall/client.js"),
  "components/restaurant-and-bar-listing/client.js": () => import("../components/restaurant-and-bar-listing/client.js"),
  "components/sailthru-personalization-pixel/client.js": () => import("../components/sailthru-personalization-pixel/client.js"),
  "components/scale-quiz/client.js": () => import("../components/scale-quiz/client.js"),
  "components/search-page-form/client.js": () => import("../components/search-page-form/client.js"),
  "components/search-remix-promo/client.js": () => import("../components/search-remix-promo/client.js"),
  "components/search-remix/client.js": () => import("../components/search-remix/client.js"),
  "components/search-results/client.js": () => import("../components/search-results/client.js"),
  "components/search/client.js": () => import("../components/search/client.js"),
  "components/senate-scrollviz-2018/client.js": () => import("../components/senate-scrollviz-2018/client.js"),
  "components/senate-table-2018/client.js": () => import("../components/senate-table-2018/client.js"),
  "components/share-button/client.js": () => import("../components/share-button/client.js"),
  "components/share-video/client.js": () => import("../components/share-video/client.js"),
  "components/simple-header/client.js": () => import("../components/simple-header/client.js"),
  "components/single-button-mag-sub-promo/client.js": () => import("../components/single-button-mag-sub-promo/client.js"),
  "components/speed-bump/client.js": () => import("../components/speed-bump/client.js"),
  "components/spiderman-map/client.js": () => import("../components/spiderman-map/client.js"),
  "components/sponsored-product/client.js": () => import("../components/sponsored-product/client.js"),
  "components/sponsored-shopping-product/client.js": () => import("../components/sponsored-shopping-product/client.js"),
  "components/sponsored-shopping/client.js": () => import("../components/sponsored-shopping/client.js"),
  "components/state-table-2018/client.js": () => import("../components/state-table-2018/client.js"),
  "components/sticky-container/client.js": () => import("../components/sticky-container/client.js"),
  "components/sticky-list/client.js": () => import("../components/sticky-list/client.js"),
  "components/subscription-button/client.js": () => import("../components/subscription-button/client.js"),
  "components/subscription-form-billing-address/client.js": () => import("../components/subscription-form-billing-address/client.js"),
  "components/subscription-form-credit-card/client.js": () => import("../components/subscription-form-credit-card/client.js"),
  "components/subscription-form-gift-recipient/client.js": () => import("../components/subscription-form-gift-recipient/client.js"),
  "components/subscription-form-link/client.js": () => import("../components/subscription-form-link/client.js"),
  "components/subscription-gift-promo/client.js": () => import("../components/subscription-gift-promo/client.js"),
  "components/subscription-multi-step-container/client.js": () => import("../components/subscription-multi-step-container/client.js"),
  "components/subscription-order-summary/client.js": () => import("../components/subscription-order-summary/client.js"),
  "components/subscription-plans-content/client.js": () => import("../components/subscription-plans-content/client.js"),
  "components/taboola/client.js": () => import("../components/taboola/client.js"),
  "components/tags/client.js": () => import("../components/tags/client.js"),
  "components/thecut-provider-tool/client.js": () => import("../components/thecut-provider-tool/client.js"),
  "components/top-package-nav/client.js": () => import("../components/top-package-nav/client.js"),
  "components/tutorial-content/client.js": () => import("../components/tutorial-content/client.js"),
  "components/tutorial/client.js": () => import("../components/tutorial/client.js"),
  "components/tv-recap-feed/client.js": () => import("../components/tv-recap-feed/client.js"),
  "components/tv-show/client.js": () => import("../components/tv-show/client.js"),
  "components/vertical-center-timeline-event/client.js": () => import("../components/vertical-center-timeline-event/client.js"),
  "components/vertical-navigation/client.js": () => import("../components/vertical-navigation/client.js"),
  "components/video-promo-for-articles/client.js": () => import("../components/video-promo-for-articles/client.js"),
  "components/video-theater-overlay/client.js": () => import("../components/video-theater-overlay/client.js"),
  "components/video-theater/client.js": () => import("../components/video-theater/client.js"),
  "components/video/client.js": () => import("../components/video/client.js"),
  "components/volume-video/client.js": () => import("../components/volume-video/client.js"),
  "components/vue-search-bar/client.js": () => import("../components/vue-search-bar/client.js"),
  "components/walking-tour-nav/client.js": () => import("../components/walking-tour-nav/client.js"),
  "components/youtube/client.js": () => import("../components/youtube/client.js")
};

// ── Component mounting (Vite bootstrap) ─────────────────────────────────────
var CLAY_INSTANCE_KIND = /_components\/(.+?)(\/instances|$)/;

// Normalize unknown thrown values into a consistent JSON-friendly payload so
// mount diagnostics are readable in browser consoles and issue reports.
function serializeError(error) {
  if (error == null) return { message: 'Unknown error' };
  if (typeof error === 'string') return { message: error };
  if (typeof error !== 'object') return { message: String(error) };

  var payload = {
    name: error.name || null,
    message: error.message || String(error),
    stack: error.stack || null,
  };

  if (error.code != null) payload.code = error.code;
  if (error.cause != null) payload.cause = serializeError(error.cause);

  return payload;
}

// Record one structured error entry for preload/load/mount failures and emit
// an expandable console group with the full context.
function reportComponentError(errors, detail) {
  var payload = {
    phase: detail.phase,
    component: detail.component,
    moduleKey: detail.moduleKey,
    uri: detail.uri,
    error: serializeError(detail.error),
  };
  var message = payload.error && payload.error.message ? payload.error.message : 'Unknown error';
  var header = '[clay vite] ' + payload.phase + ' error in ' + payload.component + ': ' + message;

  errors.push(payload);

  if (console.groupCollapsed) {
    console.groupCollapsed(header);
    console.error(payload);
    console.groupEnd();
  } else {
    console.error(header, payload);
  }
}

function mountComponentModules() {
  performance.mark('clay-components-start');

  return new Promise(function(resolve) {
    var iterator = document.createNodeIterator(
      document.documentElement,
      NodeFilter.SHOW_COMMENT,
      function(node) {
        return node.nodeValue && node.nodeValue.indexOf('_components/') !== -1
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP;
      }
    );

    var node, preloads = [];

    while ((node = iterator.nextNode())) {
      var pm = node.nodeValue.match(CLAY_INSTANCE_KIND);

      if (pm) {
        var preloadKey = 'components/' + pm[1] + '/client.js';

        if (_clayClientModules[preloadKey]) {
          preloads.push({
            component: pm[1],
            moduleKey: preloadKey,
            promise: _clayClientModules[preloadKey](),
          });
        }
      }
    }

    resolve(preloads);
  }).then(function(preloads) {
    var errors = [];
    var preloadPromises = preloads.map(function(entry) { return entry.promise; });

    return Promise.allSettled(preloadPromises).then(function(results) {
      results.forEach(function(result, idx) {
        if (result.status === 'rejected') {
          reportComponentError(errors, {
            phase: 'preload',
            component: preloads[idx].component,
            moduleKey: preloads[idx].moduleKey,
            uri: null,
            error: result.reason,
          });
        }
      });
      return { errors: errors };
    });
  }).then(function(state) {
    var errors = state.errors;
    var els = Array.from(document.querySelectorAll('[data-uri*="_components/"]'));
    var mounted = 0;

    return Promise.allSettled(els.map(function(el) {
      var m = CLAY_INSTANCE_KIND.exec(el.dataset.uri);

      if (!m) return Promise.resolve();

      var name   = m[1];
      var key    = 'components/' + name + '/client.js';
      var loader = _clayClientModules[key];

      if (!loader) return Promise.resolve();

      return loader()
        .then(function(mod) { return mod.default != null ? mod.default : mod; })
        .then(function(mod) {
          if (typeof mod === 'function') {
            try {
              mod(el);
              mounted++;
            } catch (e) {
              reportComponentError(errors, {
                phase: 'mount',
                component: name,
                moduleKey: key,
                uri: el.dataset.uri || null,
                error: e,
              });
            }
          } else if (window.DS && typeof window.DS.get === 'function') {
            try {
              window.DS.get(name, el);
              mounted++;
            } catch (e) {
              reportComponentError(errors, {
                phase: 'ds-mount',
                component: name,
                moduleKey: key,
                uri: el.dataset.uri || null,
                error: e,
              });
            }
          }
        })
        .catch(function(e) {
          reportComponentError(errors, {
            phase: 'load',
            component: name,
            moduleKey: key,
            uri: el.dataset.uri || null,
            error: e,
          });
        });
    })).then(function() {
      console.debug('[clay vite] mounted ' + mounted + '/' + els.length + ' components');
      if (errors.length) {
        var summary = errors.map(function(entry) {
          return {
            phase: entry.phase,
            component: entry.component,
            moduleKey: entry.moduleKey,
            uri: entry.uri,
            message: entry.error && entry.error.message,
          };
        });
        console.warn('[clay vite] mount errors (' + errors.length + ')');
        if (console.table) console.table(summary);
        console.error('[clay vite] mount error details', errors);
      }
    });
  }).finally(function() {
    performance.mark('clay-components-end');
    performance.measure('clay-components', 'clay-components-start', 'clay-components-end');
    var dur = (performance.getEntriesByName('clay-components').pop() || {}).duration;

    console.debug('[clay vite] components took ' + dur + 'ms');
  });
}

mountComponentModules().catch(console.error);
